<template>
  <div class="navigation-container" v-if="$auth.ready() && !$auth.check()">
    <v-navigation-drawer temporary right touchless
                         fixed disable-route-watcher
                         v-model="drawer" app>
      <v-list class="app-menu-wrapper">
        <p class="close-menu">
          <a @click.stop="drawer = !drawer">
            <v-icon>close</v-icon>
          </a>
        </p>
        <v-list-item>
          <v-list-item-content @click="goContact()" :class="['menu-element-wrapper', {'selected': isContact}]">
            <v-list-item-title>
              {{$t("home.header.menu.contact") }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content @click="goLogin()" :class="['menu-element-wrapper', {'selected': isLogin}]">
            <v-list-item-title>
              {{$t("home.header.menu.login") }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-select prepend-icon="language" solo item-text="label"
                style="margin-left: 15px;"
                item-value="value" :items="langs" v-model="lang"/>
    </v-navigation-drawer>

    <v-toolbar absolute>
      <v-toolbar-title>
        <img src="../../assets/logo.png" alt="">
      </v-toolbar-title>
      <v-spacer/>
      <v-toolbar-items v-if="$vuetify.breakpoint.mdAndDown">
        <v-icon large @click.stop="drawer = !drawer" :ripple="false">dehaze</v-icon>
      </v-toolbar-items>
      <v-toolbar-items v-if="$vuetify.breakpoint.lgAndUp">
        <v-btn :class="[{'selected': isContact}]" outlined @click="goContact()">
          {{$t("home.header.menu.contact") }}
        </v-btn>
        <v-btn :class="[{'selected': isLogin}]" outlined @click="goLogin()" v-if="!isLogin">
          {{$t("home.header.menu.login") }}
        </v-btn>
        <v-select solo prepend-icon="language" item-text="label"
                  item-value="value" :items="langs" v-model="lang"/>
      </v-toolbar-items>
    </v-toolbar>
  </div>
</template>

<script>
  import i18next from 'i18next';

  export default {
    data: () => ({
      drawer: null,
      langs: [{label: 'Deutsch', value: 'DE'}, {label: 'Italiano', value: 'IT'}],
      lang: 'DE',
    }),
    watch: {
      lang(language) {
        this.$store.dispatch('setLanguage', language);
        i18next.changeLanguage(this.$store.getters.getLanguage);
        this.globalEvents.$emit('languageChanged');
      },
    },
    mounted() {
      if (window.location.hostname !== undefined
        && window.location.hostname.indexOf('toursol.it') !== -1) {
        setTimeout(() => {
          this.lang = 'IT';
        }, 1000);
      } else {
        if (this.$store.getters.getLanguage !== undefined) {
          i18next.changeLanguage(this.$store.getters.getLanguage);
          this.lang = this.$store.getters.getLanguage;
          this.globalEvents.$emit('languageChanged');
        }
      }
    },
    methods: {
      goTo(target) {
        this.closeMenu();
        this.$vuetify.goTo(target, this.options);
      },
      closeMenu() {
        if (this.drawer) {
          this.drawer = !this.drawer;
        }
      },
      goHome() {
        this.closeMenu();
        this.$router.push({name: 'Home'});
      },
      goAbout() {
        this.closeMenu();
        this.$router.push({name: 'About'});
      },
      goContact() {
        this.closeMenu();
        this.$router.push({name: 'Contact'});
      },
      goLogin() {
        this.closeMenu();
        this.$router.push({name: 'Login'});
      },
      goToLanding() {
        this.closeMenu();
        this.$router.push({name: 'Home'});
      }
    },
    computed: {
      isHome() {
        return this.$route.name === 'Home';
      },
      isAbout() {
        return this.$route.name === 'About';
      },
      isContact() {
        return this.$route.name === 'Contact';
      },
      isLogin() {
        return this.$route.name === 'Login';
      },
      options () {
        return {
          duration: 700,
          offset: 65,
          easing: 'easeInOutCubic',
        }
      },
    }
  };
</script>

<style lang="scss">
  @import "../../assets/scss/layout";
  @import "../../assets/scss/variables";

  .navigation-container {
    .app-menu-wrapper {
      text-align: left;
    }

    .close-menu {
      min-height: 45px;
      a {
        float: right;
        margin-right: 20px;
        margin-top: 10px;
        i {
          color: $primary-text;
          font-size: 35px;
        }
      }
    }

    .menu-element-wrapper {
      border-bottom: 1px solid $primary-text;

      &.selected {
        color: $primary;
        border-bottom: 1px solid $primary;
      }

    }

    .v-toolbar {
      background: white !important;
      color: $primary-text !important;
      position: fixed !important;
      top: 0 !important;
      width: 100% !important;
      z-index: 100 !important;
      .v-toolbar__content {
        background-color: white;
        .v-toolbar__title {
          display: flex;
          img {
            height: 38px;
            cursor: pointer;
            @include MQ(XS) {
              height: 32px;
            }
          }
          .name {
            margin-left: 20px;
            font-weight: 600;
          }
        }
        .v-toolbar__items {
          height: auto;
          .v-icon {
            cursor: pointer;
            color: $primary-text !important;
            &:hover {
              color: $primary;
            }
          }
          .v-btn {
            margin-right: 15px;
            height: 36px !important;
            color: $primary-text;

            &.selected {
              color: $primary;
            }

            &:hover {
              color: $primary;
            }
          }
        }
      }
    }

    .v-input {
      height: 36px !important;
      min-width: 140px;
      .v-input__prepend-outer {
        margin-top: 6px !important;
        margin-right: 0;
      }
      .v-input__control {
        height: 100%;
        .v-input__slot {
          background-color: transparent !important;
          box-shadow: unset !important;
          min-height: 36px;
          margin-bottom: 0;
          margin-right: 0;
          padding-right: 0;
          padding-left: 5px;
          /* IE11 */
          @media all and (-ms-high-contrast:none)
          {
            box-shadow: none !important;
          }
          .v-select__selections {
            font-weight: 600;
            max-width: 80px;
            /* IE11 */
            @media all and (-ms-high-contrast:none)
            {
              height: 31px;
            }
            input {
              width: 5px;
            }
            .v-select__selection--comma {
              margin-right: 0;
            }
          }
          .v-input__append-inner {
            margin: 0;
            padding: 0;
            .v-input__icon {
              i {
              }
            }
          }
        }
        .v-text-field__details {
          display: none;
        }
      }
    }
  }
</style>
